import React from 'react';

function MeetLink({ link }: any) {
  return <div>{link}</div>;
}

export default MeetLink;
